<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'CourseInstructorsView',
  props: {
    courseDetails: {
      type: Object,
      required: true,
    },
  },
  methods: {
    mapProfileImageUrl(userProfile: any) {
      return userProfile && userProfile.profileImageUrl 
        ? userProfile.profileImageUrl 
        : "/images/left-imgs/img-2.jpg";
    },
    hasFacebookPage(instructor: any) {
      return instructor.pageUrlFacebook && instructor.pageUrlFacebook.length > 0;
    },
    hasInstagramPage(instructor: any) {
      return instructor.pageUrlInstagram && instructor.pageUrlInstagram.length > 0;
    },
    hasLinkedinPage(instructor: any) {
      return instructor.pageUrlLinkedIn && instructor.pageUrlLinkedIn.length > 0;
    },
    truncateAbout(about: string, maxLength: number = 90) {
      if (!about) return '';
      return about.length > maxLength 
        ? about.substring(0, maxLength) + '...' 
        : about;
    }
  }
});
</script>

<template>
  <div class="course_instructors_grid_wrapper">
    <div
      v-if="!courseDetails.instructors || courseDetails.instructors.length === 0"
      class="course_instructors_empty"
    >
      <div class="empty_icon_box">
        <i class="uil uil-user-times" />
      </div>
      <p class="empty_title">
        Sin profesores asignados
      </p>
      <p class="empty_desc">
        Aún no se han asignado docentes para este curso.
      </p>
    </div>

    <el-row
      v-else
      :gutter="24"
    >
      <el-col 
        v-for="instructor in courseDetails.instructors" 
        :key="instructor.id"
        :xs="24" 
        :sm="12" 
        :md="12" 
        :lg="8" 
        :xl="6"
        class="instructor_col"
      >
        <div class="instructor_card_modern">
          <div class="instructor_avatar_box">
            <img 
              :src="mapProfileImageUrl(instructor.userProfile)" 
              alt="Instructor"
              class="instructor_avatar_img"
            >
            <span class="instructor_verified_badge" title="Docente Verificado">
              <i class="uil uil-check" />
            </span>
          </div>

          <div class="instructor_card_body">
            <h4 class="instructor_name">
              {{ instructor.userProfile?.firstName || 'Docente' }} {{ instructor.userProfile?.lastName || '' }}
            </h4>
            <span class="instructor_role_chip">
              {{ instructor.educationSpecialty || 'Especialista Académico' }}
            </span>

            <p
              v-if="instructor.about"
              class="instructor_about_text"
            >
              {{ truncateAbout(instructor.about) }}
            </p>

            <div class="instructor_card_footer">
              <ul class="instructor_social_list">
                <li v-if="hasFacebookPage(instructor)">
                  <a
                    :href="instructor.pageUrlFacebook"
                    class="social_icon_btn fb"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-facebook-f" />
                  </a>
                </li>
                <li v-if="hasInstagramPage(instructor)">
                  <a
                    :href="instructor.pageUrlInstagram"
                    class="social_icon_btn in"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-instagram" />
                  </a>
                </li>
                <li v-if="hasLinkedinPage(instructor)">
                  <a
                    :href="instructor.pageUrlLinkedIn"
                    class="social_icon_btn ln"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <i class="fab fa-linkedin-in" />
                  </a>
                </li>
              </ul>

              <el-popover 
                placement="top" 
                trigger="click" 
                popper-class="detail-instructor-popover"
                :width="320"
              >
                <template #reference>
                  <el-button
                    type="primary"
                    link
                    class="instructor_more_btn"
                  >
                    <i class="uil uil-info-circle" /> Ver perfil
                  </el-button>
                </template>
                <div class="instructor_popover_content">
                  <div class="popover_header">
                    <img 
                      :src="mapProfileImageUrl(instructor.userProfile)" 
                      alt="" 
                      class="popover_avatar"
                    >
                    <div>
                      <h5>{{ instructor.userProfile?.firstName }} {{ instructor.userProfile?.lastName }}</h5>
                      <span class="popover_spec">{{ instructor.educationSpecialty || 'Especialista' }}</span>
                    </div>
                  </div>
                  <div
                    v-if="instructor.about"
                    class="popover_section"
                  >
                    <h6>Acerca</h6>
                    <p>{{ instructor.about }}</p>
                  </div>
                  <div
                    v-if="hasFacebookPage(instructor) || hasInstagramPage(instructor) || hasLinkedinPage(instructor)"
                    class="popover_section"
                  >
                    <h6>Redes</h6>
                    <div class="popover_socials">
                      <a
                        v-if="hasFacebookPage(instructor)"
                        :href="instructor.pageUrlFacebook"
                        target="_blank"
                        class="fb"
                      ><i class="fab fa-facebook-f" /></a>
                      <a
                        v-if="hasInstagramPage(instructor)"
                        :href="instructor.pageUrlInstagram"
                        target="_blank"
                        class="in"
                      ><i class="fab fa-instagram" /></a>
                      <a
                        v-if="hasLinkedinPage(instructor)"
                        :href="instructor.pageUrlLinkedIn"
                        target="_blank"
                        class="ln"
                      ><i class="fab fa-linkedin-in" /></a>
                    </div>
                  </div>
                </div>
              </el-popover>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
